@if (tray.bubbles().length > 0) {
  <div class="__overlay-tray">
    @for (bubble of tray.bubbles(); track bubble.id) {
      <div class="__bubble" (click)="bubble.onRestore()">
        <div class="__bubble-info">
          <span class="__bubble-caption">{{ bubble.caption }}</span>
          <span class="__bubble-title">{{ bubble.title }}</span>
        </div>
        <button
          mat-icon-button
          class="__bubble-close"
          (click)="$event.stopPropagation(); bubble.onClose()">
          <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
      </div>
    }
  </div>
}
